import React, { useState } from "react";
import { connect } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import "../../assets/css/ResetPassword.css";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import {
    clientLogo1,
    clientLogo2,
    clientLogo3,
    clientLogo4,
    clientLogo5,
    clientLogo6,
} from "../../Constant";

import { ResetPasswordAction } from "../../redux/actions/auth";

const ResetPassword = ({ ResetPasswordAction }) => {
    const { email, code } = useParams();
    const [newPassword, setNewPassword] = useState("");
    const [confirmNewPassword, setConfirmNewPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();

    const submit = async (e) => {
        e.preventDefault();
        try {
            await ResetPasswordAction(
                email,
                code,
                newPassword,
                confirmNewPassword,
                () => navigate("/")
            );
        } catch (err) {
            console.log(err);
        }
    };

    return (
        <>
            <Header />
            {/* <!-- Sign In ec Start Here --> */}
            <section className="signin_sec">
                <div className="container">
                    <div className="row">
                        <div className="col-md-3"></div>
                        <div className="col-md-6">
                            <div className="signin_box">
                                <div className="heading">
                                    <h5>Reset Password</h5>
                                </div>
                                <form
                                    id="resetForm"
                                    className="form"
                                    action=""
                                    method="post"
                                    onSubmit={submit}
                                >
                                    <div className="form-group">
                                        <label htmlFor="new-pass">
                                            New Password
                                        </label>
                                        <input
                                            type={
                                                showPassword
                                                    ? "text"
                                                    : "password"
                                            }
                                            id="password"
                                            placeholder="Enter your new password"
                                            className="form-control"
                                            value={newPassword}
                                            onChange={(e) =>
                                                setNewPassword(e.target.value)
                                            }
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="confirm-pass">
                                            Confirm New Password
                                        </label>
                                        <input
                                            type={
                                                showPassword
                                                    ? "text"
                                                    : "password"
                                            }
                                            id="confirm_password"
                                            placeholder="Confirm Password"
                                            className="form-control"
                                            value={confirmNewPassword}
                                            onChange={(e) =>
                                                setConfirmNewPassword(
                                                    e.target.value
                                                )
                                            }
                                            required
                                        />
                                    </div>
                                    <div className="show-passDv">
                                        <div className="form-group showpass">
                                            <input
                                                type="checkbox"
                                                id="show_pass"
                                                // className="form-control"
                                                onChange={(e) =>
                                                    setShowPassword(
                                                        e.target.checked
                                                    )
                                                }
                                            />
                                            <label htmlFor="show_pass">
                                                Show Password
                                            </label>
                                        </div>
                                    </div>
                                    <input
                                        type="submit"
                                        name="submit"
                                        className="logins_btn submit_btn"
                                        value="Reset"
                                    />
                                    {/* <!--                        <button className="logins_btn submit_btn">Sign in</button>--> */}
                                </form>
                                <div className="policyDv">
                                    <p>
                                        By signing in or signing up, I agree to
                                        myhomehelper.com's
                                        {/* <Link to="/">
                                            Terms of Service
                                        </Link> and  */}
                                        <Link to="/privacy-policy">
                                            Privacy Policy
                                        </Link>
                                        , confirm that I am 18 years of age or
                                        older, and consent to receiving email
                                        communication.
                                    </p>
                                </div>
                                <div className="have_account">
                                    <p>
                                        Not a Member?
                                        <Link to={"/signup"}>Sign up</Link>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3"></div>
                    </div>
                </div>
            </section>
            {/* <!-- Sign In ec Start Here --> */}

            {/* <!-- Brands Div Start Here --> */}
            <section className="brandsDv">
                <div className="container">
                    <hr />
                    <div className="row">
                        <div className="col-lg-2 col-md-4">
                            <div className="brand_img">
                                <figure>
                                    <img src={clientLogo1} alt="" />
                                </figure>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-4">
                            <div className="brand_img">
                                <figure>
                                    <img src={clientLogo2} alt="" />
                                </figure>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-4">
                            <div className="brand_img">
                                <figure>
                                    <img src={clientLogo3} alt="" />
                                </figure>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-4">
                            <div className="brand_img">
                                <figure>
                                    <img src={clientLogo4} alt="" />
                                </figure>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-4">
                            <div className="brand_img">
                                <figure>
                                    <img src={clientLogo5} alt="" />
                                </figure>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-4">
                            <div className="brand_img">
                                <figure>
                                    <img src={clientLogo6} alt="" />
                                </figure>
                            </div>
                        </div>
                    </div>
                    <hr />
                </div>
            </section>
            {/* <!-- Brands Div End Here --></div> */}
            <Footer />
        </>
    );
};

const mapDispatchToProps = (dispatch) => ({
    ResetPasswordAction: async (email, code, password, confirm_password, cb) =>
        dispatch(
            await ResetPasswordAction(
                email,
                code,
                password,
                confirm_password,
                cb
            )
        ),
});

export default connect(null, mapDispatchToProps)(ResetPassword);
